import { render, staticRenderFns } from "./SlideManager.vue?vue&type=template&id=3b63feb0&"
import script from "./SlideManager.vue?vue&type=script&lang=js&"
export * from "./SlideManager.vue?vue&type=script&lang=js&"
import style0 from "./SlideManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports